import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    chipContent: {
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.text[600],
        fontWeight: 400,
    },
    chipPrefix: {
        color: theme.colors.text[700],
        fontWeight: 600,
        marginRight: '4px',
    },
    chipIcon: {
        marginLeft: theme.spacing(1),
        '&:hover': {
            fill: theme.colors.primary.contrastBlack,
        },
    },
    option: {
        marginLeft: 0,
        marginRight: theme.spacing(1),
        '& .MuiTypography-root': {
            fontSize: 14,
            color: theme.colors.gray['900'],
        },
        '& .MuiRadio-root': {
            color: theme.colors.gray['200'],
        },
        '& .Mui-checked': {
            color: theme.colors.primary.main,
        },
    },
}));
//# sourceMappingURL=RadioButtonMenu.styles.js.map